import { render, staticRenderFns } from "./CalendarDetails.vue?vue&type=template&id=4ac40697&"
import script from "./CalendarDetails.vue?vue&type=script&lang=js&"
export * from "./CalendarDetails.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports